/** Survey History to get view history list*/
export const SURVEY_HISTORY_GET_LIST = 'SURVEY_HISTORY_GET_LIST';
export const SURVEY_HISTORY_GET_LIST_NONE = 'SURVEY_HISTORY_GET_LIST_NONE';
export const SURVEY_HISTORY_GET_LIST_IN_PROGRESS = 'SURVEY_HISTORY_GET_LIST_IN_PROGRESS';
export const SURVEY_HISTORY_GET_LIST_SUCCESS = 'SURVEY_HISTORY_GET_LIST_SUCCESS';
export const SURVEY_HISTORY_GET_LIST_FAIL = 'SURVEY_HISTORY_GET_LIST_FAIL';